import cache from 'utils/cache'

const SSO_FLAG_KEY = 'isSSO'

export function isSsoMode() {
  return !!cache.get('isSSO') || sessionStorage.getItem(SSO_FLAG_KEY) === '1'
}

export function markSsoMode() {
  cache.set('isSSO', true)
  sessionStorage.setItem(SSO_FLAG_KEY, '1')
}

export function clearSsoMode() {
  cache.remove('isSSO')
  sessionStorage.removeItem(SSO_FLAG_KEY)
}
